<template>
    <div style="display:none">
        test
    </div>
</template>
<script>
    import { getUrlKey } from '@/common/util.js';
    import fetch from '../../libs/fetch'
    import store from "../../store";
    export default {
      //生命周期函数
      created() {
        let navUrl = localStorage.getItem("now_url");
        // if (!navUrl) {
        //   navUrl = '/user'
        // }
        // localStorage.removeItem('now_url');
        const code = getUrlKey("code") // 截取code
        const appId = localStorage.getItem('appId')
        const openId = localStorage.getItem('openId')
        if (!openId) {
          if (!code) {
            const local = window.location.href
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appId=' + appId + '&redirect_uri='
              + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
          } else {
            let url = '/pdd-user/public/mp/' + appId + '/auth?code=' + code;
            this.axios.get(url).then(res => {
              let data = res.data;
              if (data.returnStatus == 0 && data.data.openId) {
                localStorage.setItem('openId', data.data.openId);

                let url = '/pdd-user/public/mp/user?openId=' + data.data.openId;
                fetch({
                    url: url,
                    method: 'get'
                }).then(response => {
                    store.commit('setUserInfo', response.data.unionInfo);
                    this.$router.push({
                        path: navUrl
                    })
                }).catch(error => {
                    console.log(error)
                });


              } else {
                this.$toast("OpenId获取失败");
              }
            });
          }
        } else {
          this.$router.push({
            path: navUrl
          })
        }
      },
      data() {
        return {}
      },
      methods: {

      }
    }
</script>

